<i18n src="@/common/i18n/i18n-locales.json"></i18n>

<i18n>
{
  "en": {
    "title": "Order Info",
    "pleaseEnterBarcodeCarrierId": "Please enter carrier ID (without \"/\")",
    "pleaseEnterCDCCarrierId": "Please enter carrier ID",
    "pleaseEnterNpoId": "Please enter NPO ID",
    "barcodePlaceholder": "7 capital letters and numbers",
    "cdcPlaceholder": "2 Capital letters and 14 numbers",
    "npoIdPlaceholder": "3 to 8 numbers"
  },
  "zh-tw": {
    "title": "訂單資訊",
    "pleaseEnterBarcodeCarrierId": "請輸入載具 ID (不用輸入/)",
    "pleaseEnterCDCCarrierId": "請輸入載具 ID",
    "pleaseEnterNpoId": "請輸入愛心碼",
    "barcodePlaceholder": "大寫英數字、符號共7碼",
    "cdcPlaceholder": "2個大寫英文字母+14個數字",
    "npoIdPlaceholder": "數字 3~8 碼"
  }
}
</i18n>

<template>
  <prompt
    :title="`${$t(`title`)} (${$t(`receiptCarrierType.${receiptCarrier}`)})`"
    :label="label"
    :defaultValue="defaultValue"
    inputType="text"
    :placeholder="placeholder"
    :validator="validator"
    @confirm="v => setOrderParams({ receiptCarrierId: v })" />
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import Prompt from '@/common/components/Prompt'
import { validateReceiptCarrierId } from '@/common/helpers/validators'

export default {
  dependencies: ['receiptCarrierType'],
  computed: {
    ...mapState(['receiptCarrier', 'receiptCarrierId']),
    ...mapGetters(['isReceiptCarrierIdValid']),
    label () {
      const labels = {}
      labels[this.receiptCarrierType.barcode] = this.$t(`pleaseEnterBarcodeCarrierId`)
      labels[this.receiptCarrierType.cdc] = this.$t(`pleaseEnterCDCCarrierId`)
      labels[this.receiptCarrierType.donate] = this.$t(`pleaseEnterNpoId`)
      return labels[this.receiptCarrier]
    },
    placeholder () {
      const placeholders = {}
      placeholders[this.receiptCarrierType.barcode] = this.$t(`barcodePlaceholder`)
      placeholders[this.receiptCarrierType.cdc] = this.$t(`cdcPlaceholder`)
      placeholders[this.receiptCarrierType.donate] = this.$t(`npoIdPlaceholder`)
      return placeholders[this.receiptCarrier]
    },
    validator () {
      return validateReceiptCarrierId(this.receiptCarrier)
    },
    defaultValue () {
      return this.receiptCarrierId
    }
  },
  methods: {
    ...mapActions(['setOrderParams'])
  },
  components: { Prompt }
}
</script>
